// Copyright (c) 2015 Steven Sojka
import isFunction from 'lodash-es/isFunction';
import isObject from 'lodash-es/isObject';

import { resolveFunction } from '../utils';

import { ApplicateOptions, Applicator } from './Applicator';

export class MemoizeApplicator extends Applicator {
  apply({ value, instance, config: { execute }, args, target }: ApplicateOptions): any {
    let resolver = resolveFunction(
      isFunction(args[0]) ? args[0] : isObject(args[0]) ? (args[0] as any).resolver : args[0],
      instance,
      target,
      false,
    );

    if (resolver && instance) {
      resolver = resolver.bind(instance);
    }

    const memoized = resolver ? execute(value, resolver) : execute(value);

    if (isObject(args[0])) {
      const { cache, type } = args[0] as any;

      if (cache) {
        memoized.cache = cache;
      } else if (isFunction(type)) {
        memoized.cache = new (type as any)();
      }
    }

    return memoized;
  }
}
